import { CSSInterpolation } from '@emotion/serialize';

type Styles = {
  mobile?: CSSInterpolation;
  tablet?: CSSInterpolation;
  desktop?: CSSInterpolation;
};

// Avoid applying a `max-width` so that we can allow a cascading effect to
// happen, e.g. tablet styles will apply if desktop styles are not provided.
export const mediaQueries = {
  mobile: `@media (min-width: 0)`,
  tablet: `@media (min-width: 660px)`,
  desktop: `@media (min-width: 1024px)`,
};

export const getResponsiveStyles = (styles: Styles) => {
  return [
    { [mediaQueries.mobile]: styles.mobile || {} },
    { [mediaQueries.tablet]: styles.tablet || {} },
    { [mediaQueries.desktop]: styles.desktop || {} },
  ];
};

export const visibleOnlyOnMobile = getResponsiveStyles({
  mobile: { display: 'inherit', visibility: 'visible' },
  tablet: { display: 'none', visibility: 'hidden' },
  desktop: { display: 'none', visibility: 'hidden' },
});

export const visibleOnlyOnTablet = getResponsiveStyles({
  mobile: { display: 'none', visibility: 'hidden' },
  tablet: { display: 'inherit', visibility: 'visible' },
  desktop: { display: 'none', visibility: 'hidden' },
});

export const visibleOnlyOnDesktop = getResponsiveStyles({
  mobile: { display: 'none', visibility: 'hidden' },
  tablet: { display: 'none', visibility: 'hidden' },
  desktop: { display: 'inherit', visibility: 'visible' },
});

export const hiddenOnMobile = getResponsiveStyles({
  mobile: { display: 'none', visibility: 'hidden' },
  tablet: { display: 'inherit', visibility: 'visible' },
  desktop: { display: 'inherit', visibility: 'visible' },
});
export const hiddenOnDesktop = getResponsiveStyles({
  mobile: { display: 'inherit', visibility: 'visible' },
  tablet: { display: 'inherit', visibility: 'visible' },
  desktop: { display: 'none', visibility: 'hidden' },
});
